<template>
  <div>
    <r-snackbar
      v-if="snackbarVisible"
      :backgroundColor="snackbarColor"
      :message="snackbarText"
      :timeout="3000"
      @close="snackbarVisible = false"
    >
    </r-snackbar>
    <!-- #region NAVBAR   -->
    <nav >
      <ul class="nav-wrapper">
        <li class="icon" @click="handleGoBack()">
          <a href="#">
            <span class="tooltip">Go Back</span>
            <span><i class="fa-solid fa-arrow-left text-white ml-3"> </i></span>
          </a>
        </li>

        <li class="icon">
          <RouterLink to="/">
            <span class="tooltip">Home</span>
            <span><i class="fa-solid fa-house text-white ml-3"> </i></span
          ></RouterLink>
        </li>

        <li>
          <a href="#">
            <div class="ml-3 text-base lg:text-2xl text-white">
              {{ securityGroup.name }}
            </div>
          </a>
        </li>

        <li>
          <RouterLink to="/"></RouterLink>
        </li>
      </ul>
    </nav>

    <r-spinner v-if="loading"> </r-spinner>
    <div class="p-5" v-if="securityGroup">
      <div class="mb-3">
        <p class="text-sm text-gray-500">Security Group Name</p>
        <input
          type="text"
          v-model="securityGroup.name"
          placeholder="Security Group Name"
          maxlength="100"
          name="securityGroupName"
          id="securityGroupName"
          required
          disabled
          class="min-h-9 width-block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
        />
      </div>

      <!-- Modules -->
      <div class="border border-gray-500 rounded-md p-5 mb-1">
        <div class="flex justify-between mb-2 border-b border-gray-500">
          <div>
            <span class="text-xl text-blue-800 mr-2">Modules:</span>
            <span>{{ `${activeModules} Active Modules` }}</span>
          </div>
          <div>
            <i
              v-if="showModules"
              class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
              @click="showModules = false"
            >
            </i>

            <i
              v-else
              class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
              @click="showModules = true"
            >
            </i>
          </div>
        </div>

        <div v-if="showModules">
          <!-- Flight Board -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !flightBoardActiveKeys.length,
                  }"
                  >Flight Board:</span
                >
                <span
                  @click="toggleFlightBoardItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${flightBoardActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showFlightBoardPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showFlightBoardPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showFlightBoardPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showFlightBoardPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in flightBoardKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Assignments Board -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !assignmentsBoardActiveKeys.length,
                  }"
                  >Assignments Board:</span
                >
                <span
                  @click="toggleAssignmentsBoardItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${assignmentsBoardActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAssignmentsBoardPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAssignmentsBoardPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAssignmentsBoardPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAssignmentsBoardPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in assignmentsBoardKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Notifications -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !notificationsActiveKeys.length,
                  }"
                  >Notifications:</span
                >
                <span
                  @click="toggleNotificationsItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${notificationsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showNotificationsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showNotificationsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showNotificationsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showNotificationsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in notificationsKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Bidlines -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !bidlinesActiveKeys.length,
                  }"
                  >Bidlines:</span
                >
                <span
                  @click="toggleBidlinesItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${bidlinesActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showBidlinesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showBidlinesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showBidlinesPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showBidlinesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in bidlinesKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Administration -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !administrationActiveKeys.length,
                  }"
                  >Administration:</span
                >
                <span
                  @click="toggleAdministrationItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${administrationActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAdministrationPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAdministrationPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAdministrationPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAdministrationPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in administrationKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Activity Reports -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activityReportsActiveKeys.length,
                  }"
                  >Activity Reports:</span
                >
                <span
                  @click="toggleActivityReportsItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${activityReportsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showActivityReportsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showActivityReportsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showActivityReportsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showActivityReportsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in activityReportsKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Security Groups -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !securityGroupsActiveKeys.length,
                  }"
                  >Security Groups:</span
                >
                <span
                  @click="toggleSecurityGroupsItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${securityGroupsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showSecurityGroupsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showSecurityGroupsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showSecurityGroupsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showSecurityGroupsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in securityGroupsKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Airports -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !airportsActiveKeys.length,
                  }"
                  >Airports:</span
                >
                <span
                  @click="toggleAirportsItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${airportsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAirportsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAirportsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAirportsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAirportsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in airportsKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Aircraft -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !aircraftActiveKeys.length,
                  }"
                  >Aircraft:</span
                >
                <span
                  @click="toggleAircraftItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${aircraftActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAircraftPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAircraftPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAircraftPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAircraftPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in aircraftKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Crew Requirements -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !crewRequirementsActiveKeys.length,
                  }"
                  >Crew Requirements:</span
                >
                <span
                  @click="toggleCrewRequirementsItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${crewRequirementsActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showCrewRequirementsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showCrewRequirementsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showCrewRequirementsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showCrewRequirementsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in crewRequirementsKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Reports -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !reportsActiveKeys.length,
                  }"
                  >Reports:</span
                >
                <span @click="toggleReportsItems" class="cursor-pointer mr-2">{{
                  `${reportsActiveKeys.length} Active Authorizations`
                }}</span>
              </div>
              <div>
                <i
                  v-if="showReportsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showReportsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showReportsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showReportsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in reportsKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- My Monarch -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !myMonarchActiveKeys.length,
                  }"
                  >My Monarch:</span
                >
                <span
                  @click="toggleMyMonarchItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${myMonarchActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showMyMonarchPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showMyMonarchPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showMyMonarchPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showMyMonarchPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in myMonarchKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- About Monarch -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !aboutMonarchActiveKeys.length,
                  }"
                  >About Monarch:</span
                >
                <span
                  @click="toggleAboutMonarchItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${aboutMonarchActiveKeys.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showAboutMonarchPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showAboutMonarchPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showAboutMonarchPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showAboutMonarchPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in aboutMonarchKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
          <!-- Manuals -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !manualsActiveKeys.length,
                  }"
                  >Manuals:</span
                >
                <span @click="toggleManualsItems" class="cursor-pointer mr-2">{{
                  `${manualsActiveKeys.length} Active Authorizations`
                }}</span>
              </div>
              <div>
                <i
                  v-if="showManualsPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showManualsPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showManualsPanel = true"
                >
                </i>
              </div>
            </div>
            <div v-if="showManualsPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(item, index) in manualsKeys"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-400 cursor-pointer"
                  @click="showItemDescription(item)"
                >
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border border-gray-500 rounded-md p-5 mb-1">
        <div class="flex justify-between mb-2 border-b border-gray-500">
          <div>
            <span class="text-xl text-blue-800 mr-2">Other Authorizations</span>
          </div>
          <div>
            <i
              v-if="showOtherAuthorizations"
              class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
              @click="showOtherAuthorizations = false"
            >
            </i>

            <i
              v-else
              class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
              @click="showOtherAuthorizations = true"
            >
            </i>
          </div>
        </div>

        <div v-if="showOtherAuthorizations">
          <!-- Companies -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !activeCompanies.length,
                  }"
                  >Companies:</span
                >
                <span
                  @click="toggleCompaniesItems"
                  class="cursor-pointer mr-2"
                  >{{ `${activeCompanies.length} Active Companies` }}</span
                >
              </div>
              <div>
                <i
                  v-if="showCompaniesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showCompaniesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showCompaniesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              This list of authorized companies determines the available options
              when filtering employees and selecting a company in the employee
              profile.
            </div>
            <div v-if="showCompaniesPanel">
              <div
                class="border-b px-1 py-1"
                v-for="(item, index) in securityGroup.companies"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>

          <!-- Job Titles -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through': !activeJobTitles.length,
                  }"
                  >Job Titles:</span
                >
                <span
                  @click="toggleJobTitlesItems"
                  class="cursor-pointer mr-2"
                  >{{ `${activeJobTitles.length} Active Job Titles` }}</span
                >
              </div>

              <div>
                <i
                  v-if="showJobTitlesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showJobTitlesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showJobTitlesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              This list of authorized job titles determines the available
              options when filtering employees and selecting a job title in the
              employee profile.
            </div>
            <div v-if="showJobTitlesPanel">
              <div
                class="border-b px-1 py-1"
                v-for="(item, index) in securityGroup.jobTitles"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>

          <!-- Flight Assignment Cargo Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mt-2 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeFlightAssignmentCargoRoles.length,
                  }"
                  >Flight Assignments - Cargo Roles:</span
                >
                <span
                  @click="toggleFlightAssignmentCargoRolesItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeFlightAssignmentCargoRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showFlightAssignmentCargoRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showFlightAssignmentCargoRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showFlightAssignmentCargoRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a flight role on a "Cargo Only" type
                aircraft.</span
              >
              <span class="text-red-500 font-bold ml-2">
                Note: This list is inactive if the "Assign Flight Role" option
                is not selected.
              </span>
            </div>
            <div v-if="showFlightAssignmentCargoRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.flightAssignmentCargoRoles"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Flight Assignment Passenger Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeFlightAssignmentPassengerRoles.length,
                  }"
                  >Flight Assignments - Passenger Roles:</span
                >
                <span
                  @click="toggleFlightAssignmentPassengerRolesItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeFlightAssignmentPassengerRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showFlightAssignmentPassengerRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showFlightAssignmentPassengerRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showFlightAssignmentPassengerRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a flight role on a "Passenger" type
                aircraft.</span
              >
              <span class="text-red-500 font-bold ml-2">
                Note: This list is inactive if the "Assign Flight Role" option
                is not selected.</span
              >
            </div>
            <div v-if="showFlightAssignmentPassengerRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.flightAssignmentPassengerRoles"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Ground Assignment Cargo Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeGroundAssignmentCargoRoles.length,
                  }"
                  >Ground Assignments - Cargo Roles:</span
                >
                <span
                  @click="toggleGroundAssignmentCargoRolesItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeGroundAssignmentCargoRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showGroundAssignmentCargoRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showGroundAssignmentCargoRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showGroundAssignmentCargoRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a ground role on a "Cargo Only" type
                aircraft.</span
              >
              <span class="text-red-500 font-bold ml-2">
                >Note: This list is inactive if the "Assign Ground Role" option
                is not selected.</span
              >
            </div>
            <div v-if="showGroundAssignmentCargoRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.groundAssignmentCargoRoles"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
          <!-- Ground Assignment Passenger Roles  -->
          <div class="border border-gray-500 rounded-md p-5 mb-1">
            <div class="flex justify-between mb-2 border-b border-gray-500">
              <div>
                <span
                  class="text-xl text-blue-800 mr-2"
                  :class="{
                    'text-red-500 line-through':
                      !activeGroundAssignmentPassengerRoles.length,
                  }"
                  >Ground Assignments - Passenger Roles:</span
                >
                <span
                  @click="toggleGroundAssignmentPassengerRolesItems"
                  class="cursor-pointer mr-2"
                  >{{
                    `${activeGroundAssignmentPassengerRoles.length} Active Authorizations`
                  }}</span
                >
              </div>
              <div>
                <i
                  v-if="showGroundAssignmentPassengerRolesPanel"
                  class="fa-solid fa-chevron-up text-gray-400 cursor-pointer"
                  @click="showGroundAssignmentPassengerRolesPanel = false"
                >
                </i>

                <i
                  v-else
                  class="fa-solid fa-chevron-down text-blue-500 cursor-pointer"
                  @click="showGroundAssignmentPassengerRolesPanel = true"
                >
                </i>
              </div>
            </div>
            <div class="text-sm text-gray-500 px-2">
              <span
                >This list of authorized roles determines the available options
                when assigning a ground role on a "Passenger" type aircraft.
              </span>
              <span class="text-red-500 font-bold ml-2">
                Note: This list is inactive if the "Assign Ground Role" option
                is not selected.</span
              >
            </div>
            <div v-if="showGroundAssignmentPassengerRolesPanel">
              <div
                class="flex justify-between border-b px-1 py-1"
                v-for="(
                  item, index
                ) in securityGroup.groundAssignmentPassengerRoles"
                :key="index"
              >
                <div
                  class="w-full text-sm px-2 text-green-700 bg-green-100 rounded-md"
                  :class="{
                    'text-red-500 line-through  bg-red-100': !item.active,
                  }"
                >
                  {{ `${index + 1} - ${item.name}` }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- End of Panels -->
    </div>
  </div>
</template>

<script>
import api from "../services/api";
import authentication from "../services/authentication";
import { mixin } from "../mixins/mixin";
import RSnackbar from "../components/RSnackbar.vue";
import RSpinner from "../components/RSpinner.vue";

export default {
  name: "securityGroup",
  mixins: [mixin],
  components: { RSnackbar, RSpinner },
  data() {
    return {
      loading: false,

      inactivityTimer: null,
      showModules: false,
      showOtherAuthorizations: false,

      //-------------------------Snackbar
      snackbarVisible: false,
      snackbarText: "",
      snackbarColor: "white",
      snackbarTimeout: 5000,

      enableGroupToChangeEmployeeSecurityGroup: false,
      confirmDelete: false,

      showFlightBoardPanel: false,
      showAssignmentsBoardPanel: false,
      showNotificationsPanel: false,
      showBidlinesPanel: false,
      showAdministrationPanel: false,
      showActivityReportsPanel: false,
      showSecurityGroupsPanel: false,
      showAirportsPanel: false,
      showAircraftPanel: false,
      showCrewRequirementsPanel: false,
      showReportsPanel: false,
      showMyMonarchPanel: false,
      showAboutMonarchPanel: false,
      showManualsPanel: false,
      showCompaniesPanel: false,
      showJobTitlesPanel: false,
      showFlightAssignmentCargoRolesPanel: false,
      showFlightAssignmentPassengerRolesPanel: false,
      showGroundAssignmentCargoRolesPanel: false,
      showGroundAssignmentPassengerRolesPanel: false,
    };
  },

  mounted() {
    this.startInactivityTimer();
    document.addEventListener("click", this.resetInactivityTimer);
  },

  unmounted() {
    this.clearInactivityTimer();
    document.removeEventListener("click", this.resetInactivityTimer);
  },

  computed: {
    auth() {
      return this.$store.state.auth;
    },
    activeModules() {
      const groupedByModules = Object.values(
        this.securityGroup.keys.reduce((acc, key) => {
          if (key.active) {
            if (!acc[key.module]) {
              acc[key.module] = {
                module: key.module,
                keys: [],
              };
            }
            acc[key.module].keys.push(key);
          }
          return acc;
        }, {})
      );

      return groupedByModules.length;
    },

    securityGroup() {
      return this.$store.getters.securityGroup;
    },

    flightBoardKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Flight Board"
      );
    },
    assignmentsBoardKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Assignments Board"
      );
    },
    notificationsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Notifications"
      );
    },
    bidlinesKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Bidlines");
    },
    administrationKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Administration"
      );
    },
    activityReportsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Activity Reports"
      );
    },
    securityGroupsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Security Groups"
      );
    },
    airportsKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Airports");
    },
    aircraftKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Aircraft");
    },
    crewRequirementsKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Crew Requirements"
      );
    },
    reportsKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Reports");
    },
    myMonarchKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "My Monarch"
      );
    },
    aboutMonarchKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "About Monarch"
      );
    },
    manualsKeys() {
      return this.securityGroup.keys.filter((key) => key.module === "Manuals");
    },

    flightBoardActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Flight Board" && key.active
      );
    },
    assignmentsBoardActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Assignments Board" && key.active
      );
    },

    notificationsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Notifications" && key.active
      );
    },
    bidlinesActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Bidlines" && key.active
      );
    },
    administrationActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Administration" && key.active
      );
    },
    activityReportsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Activity Reports" && key.active
      );
    },
    securityGroupsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Security Groups" && key.active
      );
    },
    airportsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Airports" && key.active
      );
    },
    aircraftActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Aircraft" && key.active
      );
    },
    crewRequirementsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Crew Requirements" && key.active
      );
    },
    reportsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Reports" && key.active
      );
    },
    myMonarchActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "My Monarch" && key.active
      );
    },
    aboutMonarchActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "About Monarch" && key.active
      );
    },
    manualsActiveKeys() {
      return this.securityGroup.keys.filter(
        (key) => key.module === "Manuals" && key.active
      );
    },

    activeCompanies() {
      return this.securityGroup.companies.filter((company) => company.active);
    },
    activeJobTitles() {
      return this.securityGroup.jobTitles.filter((jobTitle) => jobTitle.active);
    },
    activeFlightAssignmentCargoRoles() {
      return this.securityGroup.flightAssignmentCargoRoles.filter(
        (role) => role.active
      );
    },
    activeFlightAssignmentPassengerRoles() {
      return this.securityGroup.flightAssignmentPassengerRoles.filter(
        (role) => role.active
      );
    },
    activeGroundAssignmentCargoRoles() {
      return this.securityGroup.groundAssignmentCargoRoles.filter(
        (role) => role.active
      );
    },

    activeGroundAssignmentPassengerRoles() {
      return this.securityGroup.groundAssignmentPassengerRoles.filter(
        (role) => role.active
      );
    },
  },

  methods: {
    startInactivityTimer() {
      this.clearInactivityTimer();
      this.inactivityTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.timeoutDuration);
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
    },

    resetInactivityTimer() {
      this.startInactivityTimer();
    },

    async handleAutoLogout() {
      try {
        //---------------------------------------Refresh Token
        this.loading = true;
        const accessToken = await authentication.getAccessToken();
        if (!accessToken) {
          this.loading = false;
          return;
        }

        await api.get("/auth/logout", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });

        this.loading = false;

        this.$store.commit("updateAuth", null);
        this.$store.commit("updateUser", null);
        clearTimeout(this.inactivityTimer);
        this.$router.push({ name: "home" });
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "red";
        this.snackbarVisible = true;
        this.snackbarText = `Error during auto-logout: ${error}`;

        setTimeout(() => {
          this.$store.commit("updateAuth", null);
          this.$store.commit("updateUser", null);
          clearTimeout(this.inactivityTimer);
        }, 3000);
      }
    },

    handleGoBack() {
      this.$router.push({ name: "home" });
    },

    showItemDescription(item) {
      this.snackbarText = `${item.name} - ${item.description}`;
      this.snackbarColor = "#359ff9";
      this.snackbarVisible = true;
    },
  },
};
</script>

<style scoped></style>
